var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3334 3.31676C16.4485 2.95169 16.677 2.63282 16.9857 2.40648C17.2945 2.18014 17.6673 2.05811 18.0501 2.05811C18.4329 2.05811 18.8057 2.18014 19.1144 2.40648C19.4231 2.63282 19.6516 2.95169 19.7667 3.31676L22.8667 12.8501H32.8667C33.2632 12.8351 33.6537 12.9503 33.9785 13.1782C34.3034 13.406 34.5447 13.7339 34.6656 14.1118C34.7865 14.4897 34.7804 14.8968 34.6482 15.2708C34.516 15.6449 34.2649 15.9655 33.9334 16.1834L25.8167 22.0668L28.9167 31.6168C29.0393 31.9805 29.0424 32.374 28.9256 32.7396C28.8087 33.1053 28.578 33.424 28.2671 33.6492C27.9563 33.8745 27.5815 33.9944 27.1977 33.9916C26.8138 33.9887 26.4409 33.8632 26.1334 33.6334L18.0001 27.6834L9.88341 33.5834C9.57592 33.8132 9.20302 33.9387 8.81915 33.9416C8.43528 33.9444 8.06055 33.8245 7.74969 33.5992C7.43883 33.374 7.20812 33.0553 7.09125 32.6896C6.97438 32.324 6.97747 31.9305 7.10007 31.5668L10.2001 22.0168L2.08341 16.1334C1.75188 15.9155 1.50083 15.5949 1.36861 15.2208C1.23639 14.8468 1.23028 14.4397 1.3512 14.0618C1.47212 13.6839 1.71344 13.356 2.03827 13.1282C2.3631 12.9003 2.75359 12.7851 3.15007 12.8001H13.1501L16.3334 3.31676Z",
    stroke: "#151515",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.903bc1b3.svg";
export { ForwardRef as ReactComponent };